$.fn.contactmulti = function (options) {
  const $main = $(this);
  let numb = location.href.split("=")[1];
  if (numb) {
    numb = Number(numb);
    $($main.find("select option").get(numb)).prop("selected", true);
  }
};
